import { map } from 'es-toolkit/compat';

import { Orchestration } from 'api/experimentResults';
import { formatDateTimeForUser } from 'utils/dateTime';

export const UNNAMED_RUN = 'Unnamed run';

// A post-processing run reads `<Job name>, created <date and time>`, never by its id. A job without a name is an
// unnamed run. The time is always shown so two runs on the same date do not read as one.
export const getRunLabels = (
  runs: Pick<Orchestration, 'orchestrationId' | 'createdAtMinimum'>[],
  runNames: Record<string, string | undefined>
): Record<string, string> =>
  Object.fromEntries(
    map(runs, (run) => [
      run.orchestrationId,
      `${runNames[run.orchestrationId]?.trim() || UNNAMED_RUN}, created ${formatDateTimeForUser(run.createdAtMinimum)}`,
    ])
  );
